import * as React from "react";
const SvgIconClose = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 32 30", style: {
  enableBackground: "new 0 0 32 30"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("polygon", { className: "st0", points: "31.4,28.6 17.4,14.6 30,2 28.6,0.6 16,13.2 3.4,0.6 2,2 14.6,14.6 0.6,28.6 2,30 16,16 30,30 " }));
export default SvgIconClose;
